import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import img from '../../../../assets/images/cross-icon.svg.js';
import { createCookie } from '../../utilities/backend-helpers/index.js';
import '../../atoms/buttons/enums.js';
import { isRTL } from '../../utilities/dom-helpers/index.js';
import css_248z from './alert-banner.scss.js';

class AlertBanner extends s {
    constructor() {
        super();
        this.rtl = false;
        this.closeButtonAltText = 'close';
        this.cookieName = 'alert-banner-hidden';
        this.isHidden = false;
        this._query = '(max-width: 767px)';
        this._isMobile = false;
    }
    _handleMediaQuery(event) {
        this._isMobile = event.detail.value;
        this.requestUpdate();
    }
    handleClick() {
        createCookie(this.cookieName);
        this.isHidden = true;
        const hero = document.querySelector('full-image-video');
        const content = document.querySelector('.content');
        const top = document.querySelector('.top');
        const banner = this.shadowRoot.querySelector('.alert-banner__container');
        const moveByPx = (top === null || top === void 0 ? void 0 : top.offsetHeight) - banner.offsetHeight;
        if (content && top) {
            content.style.transition = '.3s';
        }
        if (!hero)
            return;
        const heroInner = hero.shadowRoot.querySelector('.full-image-video');
        const heroContent = hero.shadowRoot.querySelector('.fixed-content');
        heroContent.style.top = `${moveByPx}px`;
        if (this._isMobile) {
            const heightWithoutBanner = window.innerHeight - (top.offsetHeight - banner.offsetHeight) + 40;
            heroInner.style.minHeight = `${heightWithoutBanner}px`;
            heroContent.style.height = `calc(100% - ${moveByPx}px`;
        }
        else {
            heroContent.style.removeProperty('height');
        }
    }
    render() {
        return x `<div class="alert-banner__container ${this.isHidden ? 'hidden' : ''} ${this
            .rtl || isRTL()
            ? 'rtl'
            : ''}"><div class="alert-banner ${this.rtl || isRTL() ? 'rtl' : ''}"><div class="info"><slot name="icon"></slot></div><slot name="header"></slot><slot name="text"></slot><div class="cta-container"><slot name="primary-cta"></slot></div><button class="close" @click="${this.handleClick}" @keyDown="${this.handleClick}" aria-label="${this.closeButtonAltText}"><img slot="icon" src="${img}" alt="${this.closeButtonAltText}"></button></div><lit-media-query .query="${this._query}" @changed="${this._handleMediaQuery}"></lit-media-query></div>`;
    }
}
AlertBanner.styles = css_248z;
__decorate([
    n({ type: Boolean })
], AlertBanner.prototype, "rtl", void 0);
__decorate([
    n({ type: String })
], AlertBanner.prototype, "closeButtonAltText", void 0);
__decorate([
    n({ type: String })
], AlertBanner.prototype, "cookieName", void 0);
__decorate([
    t()
], AlertBanner.prototype, "isHidden", void 0);
customElements.define('alert-banner', AlertBanner);

export { AlertBanner };
